import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Modal,
  MenuItem,
} from "@mui/material";
import { usePutUsers } from "../../../hooks/panelUsers/usePutUsers";

export const ModalEditUser = ({
  open,
  onClose,
  selectedUser,
  token,
  refresh,
}) => {
  const [user, setUser] = useState("");
  const [email, setEmail] = useState("");
  const [rol, setRol] = useState("");
  const { putUsers, loading } = usePutUsers({
    token,
    id: selectedUser?.id || "",
  });

  useEffect(() => {
    if (selectedUser) {
      setUser(selectedUser?.user_name || "");
      setEmail(selectedUser?.email || "");
      setRol(selectedUser?.rol || "");
    }
  }, [selectedUser]);

  const handlePutUser = async () => {
    await putUsers({ user_name: user, email, rol });
    onClose();
    refresh();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 700,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" component="h2" mb={2}>
          EDITAR USUARIO
        </Typography>
        {selectedUser && (
          <>
            <div style={{ display: "flex", gap: "20px" }}>
              <TextField
                fullWidth
                margin="normal"
                label="Nombre"
                name="name"
                value={user}
                onChange={(e) => setUser(e.target.value)}
              />
              <TextField
                fullWidth
                margin="normal"
                label="Email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <TextField
              fullWidth
              margin="normal"
              label="Rol"
              name="rol"
              select
              value={rol}
              onChange={(e) => setRol(e.target.value)}
            >
              <MenuItem value="admin">Administrador</MenuItem>
              <MenuItem value="editor">Editor</MenuItem>
              <MenuItem value="usuario">Usuario / Cliente</MenuItem>
            </TextField>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "15px", width: "100%" }}
              onClick={handlePutUser}
              disabled={loading}
            >
              Guardar Cambios
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
};
